/* eslint-disable no-restricted-syntax */
/* eslint-disable @typescript-eslint/camelcase */
import i18n from 'i18n';
import { isValid, parseISO } from 'date-fns';
import { formatDateWithMoment } from 'utils/helpers';
import { AuditLogsResults } from 'modules/audit/interfaces';
import { getResourceTypeText, getActionText, getFieldNameText } from '../utils';

export const isObjectEmpty = (obj: object): boolean =>
  Object.keys(obj)?.length === 0;

const isValidObjectValue = value => value !== null && typeof value === 'object';

export const getValueText = (component: any) => {
  const translations: Record<string, string> = {
    true: 'LOGS_PAGE.ACTIVE_KEY',
    false: 'LOGS_PAGE.INACTIVE_KEY',
    advanced: 'ADVANCED_KEY',
    platform: 'PLATFORM_KEY',
    autosky: 'Autosky',
    tsplus_remote_app: 'TSPlus (RemoteApp)',
    tsplus_all: 'TSPlus (WebBrowser HTML and RemoteApp)',
    connect: 'ConnectSky',
    rdp_direct: 'Microsoft Remote Desktop (Direct Connect)',
    rdp_app: 'Microsoft Remote Desktop (RemoteApp)',
    connect_direct: 'ConnectSky (Direct Connect)',
    tsplus: 'TSPlus (WebBrowser HTML5)',
    rdp: `Microsoft Remote Desktop (${i18n.t('FILE_KEY')})`,
    simple: 'DYNAMIC_FILTER.SIMPLE_KEY',
    every_user_already_using: i18n.t(
      'LOGS_PAGE.EVERY_USER_ALREADY_USING_REASON_KEY'
    ),
    deadline: i18n.t('PARTNER_PAGE.NEW_FRONT_MIGRATION_DEADLINE_KEY'),
  };

  const translationKey = translations[component];
  if (translationKey) {
    return i18n.t(translationKey);
  }

  if (isValid(parseISO(component))) {
    const formattedDate = formatDateWithMoment(component);
    return formattedDate === 'Invalid date' ? component : formattedDate;
  }

  if (Array.isArray(component)) {
    return component.join(',');
  }

  if (isValidObjectValue(component)) {
    let changesList = [''];

    for (const [key, value] of Object.entries(component)) {
      changesList = changesList.concat([
        `                    ${getFieldNameText(key)}: ${getValueText(value)}`,
      ]);
    }
    return `${changesList.join('\n')}`;
  }
  return component;
};

export const generateDiffList = (
  details: Record<string, [any, any]>
): string => {
  let changesList = [`${i18n.t('LOGS_PAGE.CHANGES_KEY')}:`, ''];

  for (const [key, value] of Object.entries(details)) {
    if (typeof value === 'string') {
      changesList = changesList.concat([
        `${i18n.t('LOGS_PAGE.CHANGED_FIELD_KEY')}: ${getFieldNameText(key)}`,
        `${i18n.t('LOGS_PAGE.VALUE_KEY')}: ${getValueText(value)}`,
        '',
      ]);
    }

    if (Array.isArray(value) && value?.length === 2) {
      const [oldValue, newValue] = value;

      if (oldValue !== newValue) {
        changesList = changesList.concat([
          `${i18n.t('LOGS_PAGE.CHANGED_FIELD_KEY')}: ${getFieldNameText(key)}`,
          `${i18n.t('LOGS_PAGE.OLD_VALUE_KEY')}: ${getValueText(oldValue)}`,
          `${i18n.t('LOGS_PAGE.NEW_VALUE_KEY')}: ${getValueText(newValue)}`,
          '',
        ]);
      }
    }
  }

  return `${changesList.join('\n')}\n`;
};

export const generateInfoText = (data: AuditLogsResults): string => {
  const lines = [
    `${i18n.t('DATE_KEY')}: ${formatDateWithMoment(data?.created_at)}`,
    `${i18n.t('OPERATOR_KEY')}: ${i18n.t(
      data?.persistent_user_first_name
    )} ${i18n.t(data?.persistent_user_last_name)}`,
    '',
    `${i18n.t('LOGS_PAGE.RESOURCE_TYPE_KEY')}: ${i18n.t(
      getResourceTypeText(data?.resource)
    )}`,
    `${i18n.t('ACTION_KEY')}: ${i18n.t(getActionText(data?.action))}`,
    `${i18n.t('LOGS_PAGE.RESOURCE_KEY')}: ${data?.resource_identifier}`,
    `ID: ${data?.resource_uuid}`,
    '',
    '',
  ];

  return lines.join('\n');
};

export const generatePublishText = (details: Record<string, [any, any]>) => {
  let changesList = [`${i18n.t('LOGS_PAGE.PUBLISHED_SETTINGS_KEY')}:`, ''];

  for (const [key, value] of Object.entries(details)) {
    changesList = changesList.concat([
      `${getFieldNameText(key)}: ${getValueText(value)}`,
    ]);
  }
  return `${changesList.join('\n')}\n\n`;
};
